<template>
  <div>
    <h2 class="primary--text ma-6">Aktuelle Werftpunkteliste</h2>


    <div :class="['kopfbereich-sticky', { 'no-sticky': drawer }]">
        <v-row justify="left" class="ma-0 pa-0">
          <v-col cols="12" md="6">
            <v-select
              class="mb-2 ml-0 pa-0 black--text"
              outlined
              :items="schiffsliste_auswahl"
              v-model="selected_id_sar"
              item-text="schiff_name"
              item-value="id_sar"
              label="wähle Hauptmodul"
              @change="update_id_sar_global(); zeige_werftliste()"
            />
          </v-col>
          <v-col cols="10" md="6" class="mt-n10 ml-1 mb-5 pa-2  ">
            <v-text-field
              v-model="search"
              label="Filtern ..."
              append-icon="mdi-magnify"
              hide-details
              outlined
              dense
              class="mb-2"
              @focus="search = ''"
            />
          </v-col>
        </v-row>
      </div>

    <v-btn class="fab-button"
      icon 
      @click="openAddPopup" 
      style="position: absolute; top: 20px; right: 20px;">
      
      <v-icon>mdi-plus</v-icon>
    </v-btn>


    <div v-for="(gruppe, bezeichnung) in gruppierteWerftliste" :key="bezeichnung">
      <h3 v-if="bezeichnung !== 'Unbekannt'" class="mt-6 mb-2 ml-4 primary--text">{{ bezeichnung }}</h3>

      <v-row dense>
        <v-col
          v-for="item in gruppe.filter(filterItem)"
          :key="item.id_werftpunkt_sar_einheit"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card class="ma-3 pa-n7 custom-shadow " outlined 
          :style="{ opacity: istVergangen(item.werftpunkt_bis_datum) ? 0.5 : 1  }">
           
         

            <v-card-text>
              <div v-if="item.gruppen_modul_bezeichnung" class="bezeichnung">
                {{ item.gruppen_modul_bezeichnung }}
              </div>
              <div v-if="item.gruppenmodul_bezeichnung" class="bezeichnung">
                {{ item.gruppenmodul_bezeichnung }}
              </div>
              <div style="font-style: italic" v-if="item.bezeichnung" >
                {{ item.bezeichnung }}
              </div>
              <div v-if="item.einzelmodul_bezeichnung" >
                {{ item.einzelmodul_bezeichnung }}
              </div>
              <!-- <div class="mt-2">{{ item.beschreibung }}</div> -->
             
            <v-card-title v-if="item.arbeitstitel !== 'Neuer Werftpunkttitel'" 
              style="margin: -10px 0px -5px -10px ;font-weight:400; font-size: 0.9rem; padding:3px 0px 0px 10px ;color:#262626">
              {{ item.arbeitstitel }}
            </v-card-title>


              <v-textarea
                v-model="item.beschreibung"
                auto-grow
                solo
                dense
                hide-details
                placeholder=" "
                class="beschreibung-eingabe mt-4"
                :class="{ 'expanded-textarea': focusedItemId === item.id_werftpunkt_sar_einheit }"
                @focus="focusedItemId = item.id_werftpunkt_sar_einheit"
                @blur="() => { speichereBeschreibung(item); focusedItemId = null; }"
            />
                                    
            
            </v-card-text>



            <v-card-actions>
             
              <v-chip
                small
                :color="item.werftpunkt_bereich_bezeichnung ? 'primary' : 'grey'"
                text-color="white"
                class="cursor-pointer"
                v-if="item.werftpunkt_bereich_bezeichnung || userStatus > 5"
                @click="userStatus > 5 && oeffneBereichPopup(item)"
              >
                {{ item.werftpunkt_bereich_bezeichnung || 'Bereich auswählen' }}
              </v-chip>

            <v-spacer></v-spacer>

              <v-chip
                small
                :color="item.werftpunkt_bis_datum ? 'green' : 'grey lighten-1'"
                :text-color="item.werftpunkt_bis_datum ? 'white' : 'black'"
                class="cursor-pointer"
                @click="userStatus >= 4 && oeffneDatumPopup(item)"
              >
                {{ item.werftpunkt_bis_datum ? 'erledigt am: ' + $options.filters.formatDate(item.werftpunkt_bis_datum) : 'Offen' }}
              </v-chip>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>






    <v-dialog v-model="dialogAdd" max-width="400" hide-overlay>
      <v-card :style="{ boxShadow: 'none', background: 'white' }">
        <v-card-title class="headline">Module hinzufügen</v-card-title>
        <v-card-text>
          <!-- Gruppenmodule Dropdown nur anzeigen, wenn kein Einzelmodul ausgewählt wurde -->
          <v-select
            v-if="!selectedSingleModule"
            v-model="selectedGroupModule"
            :items="groupModules"
            item-value="id_zuordnung_final_gmv_sar"
            item-text="GM"
            label="Gruppenmodul"
            return-object
          ></v-select>
    
          <!-- Einzelmodule Dropdown nur anzeigen, wenn kein Gruppenmodul ausgewählt wurde -->
          <v-select
            v-if="!selectedGroupModule"
            v-model="selectedSingleModule"
            :items="singleModules"
            item-value="id_zuordnung_final_emv_sar"
            item-text="EM"
            label="Einzelmodul"
            return-object
          ></v-select>
          
              <v-textarea
              v-if="selectedGroupModule || selectedSingleModule"
              v-model="beschreibungNeuerPunkt"
              label="Beschreibung"
              auto-grow
              outlined
              dense
            ></v-textarea>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addModules">Hinzufügen</v-btn>
          <v-btn text @click="breche_ab">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    






    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Bereich auswählen</v-card-title>
        <v-card-text>
          <v-select
            v-model="ausgewaehlterBereich"
            :items="bereichsliste"
            item-value="id_werftpunkt_bereich"
            item-text="bezeichnung"
            label="Bereich"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="speichereBereich">Speichern</v-btn>
          <v-btn text @click="dialog = false">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog  v-model="datumDialog"
       
        max-width="400"
        scrollable
        class="dialog-kleinrand">
      <v-card>
        <v-card-title class="headline">erledigt am:</v-card-title>
        <v-card-text>
          
          <v-date-picker
            v-model="ausgewaehltesDatum"
            locale="de-DE"
            scrollable
            :picker-date="ausgewaehltesDatum || new Date().toISOString().substr(0, 10)"
          ></v-date-picker>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="datumDialog = false">Abbrechen</v-btn>
          <v-btn color="primary" text @click="speichereDatum">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import WerftlisteService from '@/services/WerftlisteService.js';
import SchiffeService from '@/services/SchiffeService';
import AuthService from '@/services/AuthService.js';
import { EventBus } from '../main';

export default {

  props: ['drawer'],
  data() {
    return {
      schiffsliste_auswahl: [],
      selected_id_sar:  '',
      selected_name_sar: localStorage.name_sar_ausgewaehlt_global || '',
      id_typ_sar: '',
      werftliste: [],
      search: '',
      current_user_id: '',
      ladetabelle: false,
      dialog: false,
      focusedItemId: null,
      bereichsliste: [],
      ausgewaehlterBereich: null,
      aktuellerEintrag: null,
      datumDialog: false,
      ausgewaehltesDatum: null,
      datum:  (new Date(Date.now() )).toISOString().substr(0, 10),
      date: (new Date(Date.now() )).toISOString().substr(0, 10),   
      
      dialogAdd: false,
    selectedModuleType: '',  // 'group' für Gruppenmodule, 'single' für Einzelmodule
    selectedGroupModule: null,
    selectedSingleModule: null,
    groupModules: [],
    singleModules: []  ,
    beschreibungNeuerPunkt: '',
 
        

    };
  },
  computed: {
    userStatus() {
      return this.$store.getters.getUserStatus;
    },

      gruppierteWerftliste() {
        const gruppiert = {};
        const heute = new Date();
        heute.setHours(0, 0, 0, 0);

        for (const item of this.werftliste) {
          const key = item.werftzeit_bezeichnung || 'Unbekannt';
          if (!gruppiert[key]) gruppiert[key] = [];
          gruppiert[key].push(item);
        }

        // Jetzt sortieren wir jede Gruppe intern:
        for (const key in gruppiert) {
          gruppiert[key].sort((a, b) => {
            const aDatum = a.werftpunkt_bis_datum ? new Date(a.werftpunkt_bis_datum) : null;
            const bDatum = b.werftpunkt_bis_datum ? new Date(b.werftpunkt_bis_datum) : null;

            const aErledigt = aDatum && aDatum < heute;
            const bErledigt = bDatum && bDatum < heute;

            // Keine Daten → zuerst
            if (!aDatum && bDatum) return -1;
            if (aDatum && !bDatum) return 1;

            // Nur einer erledigt → weiter unten
            if (aErledigt && !bErledigt) return 1;
            if (!aErledigt && bErledigt) return -1;

            // Beide erledigt oder beide nicht → nach Datum sortieren
            if (aDatum && bDatum) return aDatum - bDatum;

            return 0;
      });
  }

  return gruppiert;
}


  },
  filters: {
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleDateString('de-DE');
    }
  },
  
  
  
  methods: {
   

  //*************  Module hinzufügen **********************************************************************
  
  breche_ab () {
    this.dialogAdd = false;
    this.selectedGroupModule = null;
    this.selectedSingleModule = null;
    this.groupModules= [];
    this.singleModules= [];  
 

  },

  openAddPopup() {
    this.dialogAdd = true;
   this.loadGroupModules();  // Lade Gruppenmodule
   this.loadSingleModules();  // Lade Einzelmodule
  },

  // Laden der Gruppenmodule basierend auf id_sar
  async loadGroupModules() {
    try {
      const response = await WerftlisteService.zeigegruppenmodule_per_id({id_sar:this.selected_id_sar});
      this.groupModules = response.recordset;
    } catch (error) {
      console.error('Fehler beim Laden der Gruppenmodule:', error);
    }
  },

  // Laden der Einzelmodule basierend auf id_sar
  async loadSingleModules() {
    try {
      const response = await WerftlisteService.zeigeeinzelmodule_per_id({id_sar:this.selected_id_sar});
      this.singleModules = response.recordset;
    } catch (error) {
      console.error('Fehler beim Laden der Einzelmodule:', error);
    }
  },

  // Methode zum Hinzufügen der ausgewählten Module
  async addModules() {
  if (!this.selected_id_sar || (!this.selectedGroupModule && !this.selectedSingleModule)) {
    alert('Bitte ein Modul und eine SAR-Einheit auswählen.');
    return;
  }

  const isGroup = !!this.selectedGroupModule;
  const id_gmv = isGroup ? this.selectedGroupModule.id_gmv : 0;
  const id_emv = isGroup ? 0 : (this.selectedSingleModule.id_emv > 0 ? this.selectedSingleModule.id_emv : 0);
  const id_zuordnung_final_emv_sar = isGroup ? 0 : (this.selectedSingleModule.id_zuordnung_final_emv_sar > 0 ? this.selectedSingleModule.id_zuordnung_final_emv_sar : 0);
  const id_zuordnung_final_gmv_sar = isGroup ? this.selectedGroupModule.id_zuordnung_final_gmv_sar : 0;

  const schiff = this.schiffsliste_auswahl.find(s => s.id_sar === this.selected_id_sar);
  this.id_typ_sar = schiff ? schiff.schiff_module_typ : null;

  const payload = {
    id_sar: this.selected_id_sar,
    id_typ_sar: this.id_typ_sar,
    id_gmv: id_gmv,
    id_emv: id_emv,
    id_zuordnung_final_emv_sar: id_zuordnung_final_emv_sar,
    id_zuordnung_final_gmv_sar: id_zuordnung_final_gmv_sar,
    id_user: this.current_user_id,
    beschreibung: this.beschreibungNeuerPunkt || ''
  };

  try {
    await WerftlisteService.neuen_werftpunkt_einfuegen(payload);
    this.dialogAdd = false;
    this.selectedGroupModule = null;
    this.selectedSingleModule = null;
    this.beschreibungNeuerPunkt = '';
    this.zeige_werftliste();
  } catch (error) {
    console.error('Fehler beim Hinzufügen des Werftpunkts:', error);
  }
}

  //*************  Ende Module hinzufügen ******************************************************************
,

    async speichereBeschreibung(item) {
      try {
        const payload = {
          id_werftpunkt_sar_einheit: item.id_werftpunkt_sar_einheit,
          beschreibung: item.beschreibung
        };

        await WerftlisteService.speichere_werft_punkt_beschreibung(payload);
        // Optional: Erfolgsnachricht oder neu laden
        // this.zeige_werftliste();
      } catch (error) {
        console.error('Fehler beim Speichern der Beschreibung:', error);
      }
    },

    istVergangen(datum) {
        if (!datum) return false;
        const heute = new Date();
        const erledigtAm = new Date(datum);
      
      // Nur Datum vergleichen, Uhrzeit ignorieren
      heute.setHours(0, 0, 0, 0);
      erledigtAm.setHours(0, 0, 0, 0);
      return erledigtAm < heute;
    },


    oeffneDatumPopup(item) {
      this.aktuellerEintrag = item;
      this.ausgewaehltesDatum = item.werftpunkt_bis_datum || null;
      this.datumDialog = true;
    },
    
    async speichereDatum() {
      try {

        const isoDatum = new Date(this.ausgewaehltesDatum); 

        const payload = {
          id_werftpunkt_sar_einheit: this.aktuellerEintrag.id_werftpunkt_sar_einheit,
          werftpunkt_bis_datum: isoDatum
        };
        await WerftlisteService.speichere_werft_punkt_datum(payload);
        this.datumDialog = false;
        this.zeige_werftliste();
      } catch (error) {
        console.error('Fehler beim Speichern des Datums:', error);
      }
    },



    filterItem(item) {
      const query = this.search.toLowerCase();
      return [
        item.arbeitstitel,
        item.gruppen_modul_bezeichnung,
        item.gruppenmodul_bezeichnung,
        item.bezeichnung,
        item.einzelmodul_bezeichnung,
        item.beschreibung,
        item.werftpunkt_bereich_bezeichnung
      ].some(field => (field || '').toLowerCase().includes(query));
    },
    
    
    
    async zeige_sar_einheit_auswahl() {
      try {

        
        const response = await SchiffeService.zeigeschiffe();

        if (response?.msg) this.$router.push('/login');
        this.schiffsliste_auswahl = response.recordset;
        
        // Jetzt ist die Liste da → SAR aus localStorage setzen
        const gespeicherteSAR = localStorage.getItem('id_sar_ausgewaehlt_global');
        if (gespeicherteSAR) {
          this.selected_id_sar = parseInt(gespeicherteSAR);
          this.update_id_sar_global();
          this.zeige_werftliste();
        }

      } catch (error) {
        console.error('Fehler beim Laden der SAR-Einheiten:', error);
      }
    },
    async update_id_sar_global() {
      if (this.selected_id_sar) {
        localStorage.id_sar_ausgewaehlt_global = this.selected_id_sar;
        EventBus.$emit('sende_globale_id_sar', this.selected_id_sar);
      }
    },
    
    async zeige_werftliste() {
      try {
        this.ladetabelle = true;
        const response = await WerftlisteService.zeigewerftliste_per_id({ id_sar: this.selected_id_sar });
        if (response?.msg) this.$router.push('/login');
        this.werftliste = response.recordset;
        this.ladetabelle = false;
        if (this.werftliste.length > 0) {
          this.selected_name_sar = this.werftliste[0].schiff_name;
          this.selected_id_sar = this.werftliste[0].id_sar;
          this.ausgewaehltesDatum = this.werftliste[0].werftpunkt_bis_datum;
        }
      } catch (error) {
        console.error('Fehler beim Laden der Werftliste:', error);
      }
    },
    async hole_user_id() {
      try {
        const response = await AuthService.hole_user_id({});  // Holt er sich über diie middleware siehe router zeile 735  (API))
        this.current_user_id = response;
        
      } catch (err) {
        console.error('Fehler beim Abrufen der User-ID:', err);
      }
    },
    async oeffneBereichPopup(item) {
      this.aktuellerEintrag = item;
      this.ausgewaehlterBereich = item.id_werftpunkt_bereich;
      try {
        const response = await WerftlisteService.zeige_auswahl_werftpunkt_bereiche();
        this.bereichsliste = response.recordset;
        this.dialog = true;
      } catch (error) {
        console.error('Fehler beim Laden der Bereiche:', error);
      }
    },
    async speichereBereich() {
      try {
        const credentials = {
          id_werftpunkt_sar_einheit: this.aktuellerEintrag.id_werftpunkt_sar_einheit,
          id_werftpunkt_bereich: this.ausgewaehlterBereich
        };
        await WerftlisteService.speichere_bereich_werft(credentials);
        this.zeige_werftliste();
        this.dialog = false;
      } catch (error) {
        console.error('Fehler beim Speichern des Bereichs:', error);
      }
    },

    handleScroll() {
      const el = document.querySelector('.filterleiste');
      if (window.scrollY > 10) {
        el?.classList.add('scrolled');
      } else {
        el?.classList.remove('scrolled');
      }
    },
    


  },


  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    const el = document.querySelector('.filterleiste');
    if (el) el.classList.remove('scrolled');
  },


  created() {
    
          window.addEventListener('scroll', this.handleScroll);

   
            //  wenn name_sar_ausgewaehlt_global   in localStorage   bei  Modulaufruf  nicht leer ist, dann setze Anzeige ausgewähltes Schiff (selected_name_sar) aus localStorage)
            if(typeof(localStorage.name_sar_ausgewaehlt_global) !== "undefined" && localStorage.name_sar_ausgewaehlt_global !=='' ) {
                this.selected_name_sar = localStorage.name_sar_ausgewaehlt_global
            }

            if(typeof(localStorage.id_sar_ausgewaehlt_global) !== "undefined" && localStorage.id_sar_ausgewaehlt_global !=='' ) {
                this.id_sar_ausgewaehlt_global = localStorage.id_sar_ausgewaehlt_global
                this.selected_id_sar = localStorage.id_sar_ausgewaehlt_global
            }
            
            this.hole_user_id();
            this.update_id_sar_global();
            this.zeige_sar_einheit_auswahl();
            this.zeige_werftliste(this.id_sar_ausgewaehlt_global) ;  //***** Michael 

//  this.zeige_sar_einheit_auswahl();
//     this.zeige_werftliste();

    EventBus.$on('sende_globale_id_sar', val => {
      this.selected_id_sar = val;
      this.id_sar_ausgewaehlt_global =  val;
      this.zeige_werftliste();
    });

   


  }
};
</script>

<style>

.kopfbereich-sticky {
  position: sticky;
  top: 0;
  background: white;
  z-index: 20;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.kopfbereich-sticky.no-sticky {
  position: static !important;
  box-shadow: none !important;
}


.fab-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 36px !important;
  height: 36px !important;
  border-radius: 50%;
  background-color: #2c802f; /* Grün */
  color: white !important;
  font-size: 32px;
  line-height: 56px;
  text-align: center;
  border: none;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.fab-button:hover {
  background-color: #45a049;
}

.dialog-kleinrand >>> .v-card {
  margin: 20px !important;
}

.beschreibung-eingabe {
  transition: all 0.75s ease;
  min-height: 24px;
  max-height: 60px;
  overflow: hidden;
  border-bottom: 1px dotted #ccc !important;
}

.expanded-textarea {
  max-height: 150px !important;
  border-bottom: 1px dotted #ccc !important;
}


.custom-shadow {
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.3); /* leichter Schatten */
  transition: box-shadow 0.3s ease;
}

.bezeichnung {
  font-size: 0.95rem;
  color: #ba150f; /* primary : #ba150f */
  font-weight: 400;
  font-style: normal;
}


.beschreibung-eingabe .v-input__control {
  box-shadow: none !important;
  background-color: transparent !important;
  border: 1px dotted gray !important;
}

.beschreibung-eingabe textarea {
  color: #666 !important;
  font-size: 0.85rem !important;
  padding: 0 !important;
  min-height: 24px;
  line-height: 1.4;
  resize: none;
  box-shadow: none !important;
  background-color: transparent !important;

  min-height: 24px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  line-height: 1.5;
}
.beschreibung-eingabe .v-input__slot {
  box-shadow: none !important;
}
.beschreibung-eingabe .v-label {
  display: none !important;
}

.v-card {
  transition: box-shadow 0.3s ease-in-out;
}
.v-card:hover {
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
}
.cursor-pointer {
  cursor: pointer;
}
</style>
